// extracted by mini-css-extract-plugin
module.exports = {"fileClaimButton":"FileClaimButton_fileClaimButton__3ueq_"};